import { getUsers, SessionMid } from '@back-office/core';
import { useLocalStore } from 'mobx-react';
import { SelectMerchantProps, Store } from './index';

type UseViewModelReturn = {
  state: Store;
  users: SessionMid[];
};

const useViewModel = ({ setAuth }: SelectMerchantProps): UseViewModelReturn => {
  const users = getUsers() || [];

  const state = useLocalStore<Store>(() => ({
    anchorEl: null,
    merchantName: users[0]?.merchantName || '',
    clientWidth: 0,
    pick: 0,
    handleOnClick() {
      setAuth(this.pick);
    },
  }));

  return {
    state,
    users,
  };
};

export default useViewModel;
